/**
 * Feature Flags System
 *
 * Controls visibility of features during app revamp.
 * Toggle these flags to show/hide features without deleting code.
 *
 * IMPORTANT: Features hidden by flags are still accessible via direct URLs
 * for testing purposes. This allows safe, incremental migration.
 */

export const FEATURE_FLAGS = {
  // RCF Campaign Planner - being replaced by AI Workflows
  SHOW_RCF_PLANNER: false,

  // Legacy email sequences feature
  SHOW_SEQUENCES_NAV: false,

  // Custom ingredients feature
  SHOW_INGREDIENTS_NAV: false,

  // Custom angles feature
  SHOW_ANGLES_NAV: false,

  // LOE Calculator (will be extracted to standalone tool)
  ENABLE_LOE_CALCULATOR: true,

  // New navigation structure (v2)
  USE_NEW_NAVIGATION: false,

  // Streaming UX for AI workflows (Phase IV)
  ENABLE_STREAMING_UX: true,
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

/**
 * Check if a feature is enabled
 * @param flag - The feature flag to check
 * @returns true if the feature is enabled
 */
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return FEATURE_FLAGS[flag];
}

/**
 * Get all enabled features
 * @returns Array of enabled feature names
 */
export function getEnabledFeatures(): FeatureFlag[] {
  return (Object.keys(FEATURE_FLAGS) as FeatureFlag[]).filter(
    (flag) => FEATURE_FLAGS[flag]
  );
}
